import React from 'react'
import { axiosWithKey } from "~/axios"
import { userLanguageSelector } from '~/tools/localization'
import StripeCCForm from '../CreateSubscription/Billing/StripeCCForm'
import popup from '../../popup'
import { getToken } from '~/redux/user/tokens'
import Spinner from '~/components/Spinner'
import { updateUserCard } from '~/redux/user/helpers'
import jwtDecode from 'jwt-decode'
import { getBillingToken } from '~/tools/stripe';
import { StripeJS } from '~/views/Popup/views/CreateSubscription/Billing/StripeCCForm/StripeJS';
import './style.css'

class View extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      metaDataMap: {},
      loading: true
    }
  }
  async componentDidMount() {
    await StripeJS();
    this.fetchPageData()
  }

  fetchPageData = () => {
    const { internalName } = window.settings;
      getToken(token => {
        let baseUrl = ""
        var decodedToken = jwtDecode(token);
		    var tokenCountryCode = decodedToken.countryCode
        if(window.settings.apiBaseUrl === "https://prod-api.viewlift.com") {
          baseUrl = "https://prod-api-cached-2.viewlift.com"
        } else {
          baseUrl = window.settings.apiBaseUrlCached || window.settings.apiBaseUrl
        }
        return axiosWithKey({
          method: "GET",
          url: `${baseUrl}/content/pages?site=${internalName}&path=/subscribe&languageCode=${userLanguageSelector()}&includeContent=true&countryCode=${tokenCountryCode}`,
          headers: { Authorization: token }
        })
          .then(res => {
            const response = res.data.modules[0].metadataMap
            this.setState({metaDataMap: response, loading: false})
          })
          .catch();
      });
  }

  render() {
    if (this.state.loading)
      return (<div className="loading centered"><Spinner/></div>)
    const metaDataMap = this.state.metaDataMap
    return (
      <div className="update-stripe-payment centered opaque padded">
        <h2>{metaDataMap.updateBillingHeader}</h2>
        <StripeCCForm
          submitCaption={metaDataMap.updateBilling}
          processingCaption={metaDataMap.paymentProcessing || "Processing"}
          apiKey={ ((window.settings.paymentProviders || {}).stripe || {}).apiKey }
          onToken={ (token, stripeObj) => {
            return getBillingToken(token, stripeObj)
            .then(billingToken => {
              let userObj = this.props.user;
              userObj.billingInfo = billingToken;
              updateUserCard(userObj);
              popup.hide()
           })} }
          fields= {metaDataMap} />
      </div>
    )
  }
}

export default View;